var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Result = exports.Player = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Basic = require("../../../elements/Basic");

var _Logos = require("../Basic/Logos");

var _PlayerName = _interopRequireDefault(require("../Basic/PlayerName"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Standard/index.js";

var Player = function Player(_ref) {
  var nickName = _ref.nickName,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      team = _ref.team,
      imageUrl = _ref.imageUrl,
      nationality = _ref.nationality;
  var label = [nationality && _react.default.createElement(_Logos.Logo, {
    key: "logo",
    width: 17,
    height: 11,
    mr: 1,
    src: nationality.imageUrl,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 24
    }
  }), _react.default.createElement(_PlayerName.default, {
    key: "text",
    bold: true,
    pt: "2px",
    numberOfLines: 1,
    player: {
      nickName: nickName,
      firstName: firstName,
      lastName: lastName
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 9
    }
  })];
  var footer = [_react.default.createElement(_Logos.TeamLogo, {
    key: "logo",
    size: 16,
    mr: 1,
    my: 0,
    mb: 0,
    mt: "2px",
    src: (0, _get.default)(team, 'imageUrl'),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 9
    }
  }), team && _react.default.createElement(_Basic.Text, {
    key: "text",
    size: "medium",
    pt: 1,
    numberOfLines: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 13
    }
  }, team.name)];
  return _react.default.createElement(Result, {
    imageUrl: imageUrl,
    label: label,
    footer: footer,
    imageType: "player",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 12
    }
  });
};

exports.Player = Player;
Player.propTypes = {
  firstName: _propTypes.default.string.isRequired,
  lastName: _propTypes.default.string.isRequired,
  imageUrl: _propTypes.default.string.isRequired,
  team: _propTypes.default.object.isRequired,
  nationality: _propTypes.default.object
};

var Result = function Result(_ref2) {
  var imageUrl = _ref2.imageUrl,
      label = _ref2.label,
      footer = _ref2.footer,
      _ref2$circle = _ref2.circle,
      circle = _ref2$circle === void 0 ? true : _ref2$circle,
      _ref2$imageType = _ref2.imageType,
      imageType = _ref2$imageType === void 0 ? 'team' : _ref2$imageType;
  return _react.default.createElement(_Basic.Row, {
    minWidth: 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 5
    }
  }, imageUrl ? _react.default.createElement(_Basic.Column, {
    center: true,
    isFlex: true,
    mr: 3,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 13
    }
  }, circle ? _react.default.createElement(_Logos.CircleLogo, {
    size: 40,
    src: imageUrl,
    imageType: imageType,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 21
    }
  }) : _react.default.createElement(_Logos.LogoWithFallback, {
    size: 40,
    width: 40,
    height: 40,
    src: imageUrl,
    imageType: imageType,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 21
    }
  })) : null, _react.default.createElement(_Basic.Column, {
    minWidth: 0,
    height: 44,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 9
    }
  }, _react.default.createElement(_Basic.Row, {
    centerHorizontal: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 13
    }
  }, label), _react.default.createElement(_Basic.Row, {
    centerHorizontal: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 13
    }
  }, footer)));
};

exports.Result = Result;
Result.propTypes = {
  imageUrl: _propTypes.default.string.isRequired,
  label: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.object)]).isRequired,
  footer: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.object)]).isRequired,
  circle: _propTypes.default.bool,
  imageType: _propTypes.default.string
};